import React from 'react';
import classNames from 'classnames';
import { Loader } from '@fiverr-private/fit';

import classes from './style.module.scss';

const LoadingPlaceholder = () => {
    const wrapperClasses = classNames(
        classes.loadingPlaceholder,
        'flex',
        'flex-center'
    );

    return (
        <section className={wrapperClasses}>
            <Loader size={Loader.SIZES.LG}/>
        </section>
    );
};

export default LoadingPlaceholder;
